import { IconAlertCircle, IconInfo } from '@developerz/ui';
import { type JSX, Match, Switch } from 'solid-js';
import { t } from '../i18n';
import type { LinkOutcome } from '../lib/identities';
import { LINK_ERROR_KEY } from '../lib/identity-labels';

// What the link round-trip came back with (#466): the API's callback lands on
// `/account/logins?linked=<slug>` or `?link_error=<code>`. Presenter — the
// route parses the query (`linkOutcome`, `lib/identities.ts`). Each refusal is
// its own sentence; `owned_elsewhere` says the login belongs to ANOTHER person's
// account and that an administrator resolves it, because nothing the reader
// does on this page can.

export function LinkOutcomeNotice(props: { readonly outcome: LinkOutcome | null }): JSX.Element {
  return (
    <Switch>
      <Match when={props.outcome?.kind === 'linked' && props.outcome}>
        {(o) => (
          <div class="alert alert--icon" role="status">
            <IconInfo />
            <p class="alert__title">{t('logins.linked_title', { org: o().slug })}</p>
            <p class="alert__desc">{t('logins.linked_desc', { org: o().slug })}</p>
          </div>
        )}
      </Match>
      <Match when={props.outcome?.kind === 'error' && props.outcome}>
        {(o) => (
          <div class="alert alert--icon alert--destructive" role="alert">
            <IconAlertCircle />
            <p class="alert__title">{t('logins.link_error_title')}</p>
            <p class="alert__desc">
              {t(LINK_ERROR_KEY[o().kind === 'error' ? o().code : 'unknown'])}
            </p>
          </div>
        )}
      </Match>
    </Switch>
  );
}
